import TableLayout from './TableLayout';

export default TableLayout;
